module.exports = __webpack_public_path__ + "img/logo.b7193249.png";